<template>
  <div class="paymentErrorAudit">
    <el-form ref="form" :inline="true" class="form" :model="searchForm">
      <el-form-item label="合同编号" prop="contractNum">
        <el-input v-model.trim="searchForm.contractNum" placeholder="请选择合同编号" />
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model.trim="searchForm.projectName" placeholder="请选择项目名称" />
      </el-form-item>
      <el-form-item label="代理商名称" prop="orderUnit">
        <el-input v-model.trim="searchForm.orderUnit" placeholder="请选择代理商名称" />
      </el-form-item>
      <el-form-item label="部门" prop="departmentName">
        <el-input v-model.trim="searchForm.departmentName" placeholder="请选择部门" />
      </el-form-item>
      <el-form-item label="区域" prop="regionName">
        <el-input v-model.trim="searchForm.regionName" placeholder="请选择区域" />
      </el-form-item>
      <el-form-item label="申请人" prop="applicationName">
        <el-input v-model.trim="searchForm.applicationName" placeholder="请选择申请人" />
      </el-form-item>
      <el-form-item label="申请时间：" prop="createBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </div>
        </div>
      </el-form-item>
      <el-button ref="searchBtn" type="primary" :loading="tableLoading" @click="secrchClick()">
        查询
      </el-button>
      <el-button type="default" @click="resetForm">
        重置
      </el-button>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="light">
        <el-table-column prop="contractNum" label="操作" width="80" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="toPaymentErrorAudit(row)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="contractNum" label="合同编号" align="left" width="140" />
        <el-table-column prop="projectName" label="项目名称" align="left" />
        <el-table-column prop="orderUnit" label="代理商名称" align="left" />
        <el-table-column prop="transferFromCode" label="已分配金额/比例" align="right" header-align="left">
          <template v-slot="{row}">
            {{ row.assignAll }}/{{ row.proportion }}%
          </template>
        </el-table-column>
        <el-table-column prop="cancellationAmount" label="申请撤销金额" align="right" header-align="left" />
        <el-table-column prop="departmentName" label="部门" align="left" />
        <el-table-column prop="regionName" label="区域" align="left" />
        <el-table-column prop="applicationName" label="申请人" align="left" />
        <el-table-column prop="applicationTime" label="申请时间" align="left" />
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper"
          :total="page.total"
          hide-on-single-page
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <!-- 办理 -->
    <el-dialog v-if="paymentErrorAuditVisible" title="认款错误查看" :visible.sync="paymentErrorAuditVisible" width="800px">
      <checkDetail :id="approvalId" />
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="Submit">提交申请</el-button> -->
        <el-button type="default" @click="paymentErrorAuditVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import checkDetail from './checkDetail.vue';
import { checkedDistributionRecords } from '@/API';
export default {
  name: 'PaymentErrorAudit',
  components: {
    checkDetail
  },
  data () {
    return {
      tableLoading: false,
      searchForm: {
        contractNum: '',
        projectName: '',
        orderUnit: '',
        departmentName: '',
        regionName: '',
        applicationName: '',
        createBeginTime: '',
        createEndTime: ''
      },
      tableData: [],
      paymentErrorAuditVisible: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      approvalId: ''
    };
  },
  mounted () {
    this.initData();
  },
  methods: {
    initData () {
      let parmas = {
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.tableLoading = true;
      checkedDistributionRecords(parmas).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.page.total = json.data.total;
          this.tableData = json.data.list;
        }
      }).catch((err) => {
        this.tableLoading = false;
        console.log(err);
      });
    },
    secrchClick () {
      this.page.currentPage = 1;
      this.initData();
    },
    resetForm () {
      this.searchForm = {};
      this.page.currentPage = 1;
      this.page.createEndTime = '';
      this.initData();
    },
    handerCurrentChange () {
      this.initData();
    },
    toPaymentErrorAudit (row) {
      this.approvalId = row.approvalId;
      this.paymentErrorAuditVisible = true;
    }
  }
};
</script>

<style>

</style>
